import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* Original name @uswitch/trustyle.tool-tip */
import { useState } from 'react';
import { TruQuestionFilled, TruClose } from '@uswitch/spark-icons/tru';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ToolTipModal = function ToolTipModal(_ref) {
  var children = _ref.children,
      close = _ref.close,
      isOpen = _ref.isOpen,
      type = _ref.type;

  var handleKeypress = function handleKeypress(key) {
    return (key === 'Enter' || key === 'Escape') && close();
  };

  return _jsx("div", {
    sx: {
      display: isOpen ? 'flex' : 'none',
      variant: 'elements.tool-tip.base.modal.wrapper'
    },
    onClick: close,
    onKeyPress: handleKeypress,
    role: "link",
    tabIndex: 0,
    children: _jsxs("div", {
      sx: {
        width: type === 'calculator' ? ['90%', '50%'] : '100%',
        variant: 'elements.tool-tip.base.modal.content'
      },
      children: [_jsx("div", {
        sx: {
          variant: 'elements.tool-tip.base.modal.icon'
        },
        children: _jsx(TruClose, {
          color: 'rgba(0,0,0,0.6)',
          size: 18
        })
      }), children]
    })
  });
};

var Triangle = _jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "12",
  viewBox: "0 0 20 12",
  fill: "none",
  children: [_jsx("path", {
    d: "M2.12268 2.5L17.8773 2.5L10 11.2526L2.12268 2.5Z",
    fill: "white",
    stroke: "#141424"
  }), _jsx("path", {
    d: "M19.5 0L10 10.5L0.5 0L19.5 0Z",
    fill: "white"
  })]
});

var ToolTipContent = function ToolTipContent(_ref2) {
  var title = _ref2.title,
      content = _ref2.content;
  return _jsxs("div", {
    children: [_jsx("div", {
      sx: {
        fontSize: '16px',
        fontWeight: 'bold',
        pb: '10px',
        fontFamily: 'heading'
      },
      children: title
    }), _jsx("p", {
      sx: {
        fontSize: '14px',
        lineHeight: '21px',
        fontFamily: 'heading',
        textAlign: 'left',
        m: '0'
      },
      children: content
    })]
  });
};

var ToolTip = function ToolTip(_ref3) {
  var title = _ref3.title,
      content = _ref3.content,
      variant = _ref3.variant;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var toggleModal = function toggleModal() {
    return setModalOpen(!modalOpen);
  };

  var handleKeypress = function handleKeypress(key) {
    return key === 'Enter' && toggleModal();
  };

  var variantPath = function variantPath(element) {
    return "elements.tool-tip.".concat(variant ? "variants.".concat(variant) : 'base').concat(element);
  };

  return _jsxs("div", {
    onKeyPress: handleKeypress,
    onClick: toggleModal,
    role: "link",
    tabIndex: 0,
    sx: {
      variant: variantPath('.wrapper')
    },
    children: [_jsx(TruQuestionFilled, {
      color: "grey",
      size: 22
    }), _jsxs("span", {
      sx: {
        variant: variantPath('.content.desktop')
      },
      children: [_jsx(ToolTipContent, {
        title: title,
        content: content
      }), _jsx("div", {
        sx: {
          variant: variantPath('.content.desktop.arrow')
        },
        children: Triangle
      })]
    }), _jsx("div", {
      sx: {
        display: ['block', 'none']
      },
      children: _jsx(ToolTipModal, {
        close: toggleModal,
        isOpen: modalOpen,
        children: _jsx("div", {
          sx: {
            variant: variantPath('.content.mobile')
          },
          children: _jsx(ToolTipContent, {
            title: title,
            content: content
          })
        })
      })
    })]
  });
};

export default ToolTip;
//# sourceMappingURL=index.js.map